<template>
    <page>
        <module :title="`话题详情 — ${detailInfo.title || ''}`">
            <c-detail title="基础信息">
                <c-detail-item label="发布人">{{detailInfo.user_name}}</c-detail-item>
                <c-detail-item label="发布时间">{{detailInfo.create_date}}</c-detail-item>
                <c-detail-item label="跟帖数">{{detailInfo.detail_count}}</c-detail-item>
                <c-detail-item label="浏览量">{{detailInfo.pv}}</c-detail-item>
                <c-detail-item label="是否推荐">
                    <template v-slot="{data}">
                        <span v-if="detailInfo.is_recommend == 1" style="color:green">推荐</span>
                        <span v-else style="color:darkgray">不推荐</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="是否隐藏">
                    <template v-slot="{data}">
                        <span v-if="detailInfo.is_valid == 1" style="color:green">显示</span>
                        <span v-else style="color:red">隐藏</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="话题标题" full>{{detailInfo.title}}</c-detail-item>
                <c-detail-item label="话题内容" full>{{detailInfo.content}}</c-detail-item>
            </c-detail>
            <c-detail v-if="mediaList.length != 0" title="媒体文件">
                <c-detail-item label="话题图片"  full>
                    <div class="img-list flex-wrap">
                        <div v-for="(item, j) in mediaList" :key="j" style="margin-right: 10px;">
                            <c-image class="img" :src="item" size="120" preview></c-image>
                        </div>
                    </div>
                </c-detail-item>


            </c-detail>
<!--
            <c-detail title="话题参数列表">
                <div slot="custom">
                    <div class="list">
                        <div v-for="(item, i) in noteList" :key="item.id" class="item">
                            <div v-if="item.medias.length" class="img-list flex-wrap">
                                <c-image v-for="(medias, j) in item.medias" :key="j" class="img" :src="medias.file_url" size="80" preview></c-image>
                            </div>
                            <p class="content">{{item.content}}</p>
                            <div class="flex-between-center data">
                                <p>
                                    <span>点赞：{{item.thumb_count}}</span>
                                    <span>状态：{{item.is_valid == 0 ? '隐藏':'显示'}}</span>
                                    <span><a class="s-link" @click="showComment(item)">评论数：{{item.comment_count}}条</a></span>
                                </p>
                                <p>
                                    <span style="color: #999;">更新时间：{{item.create_date}}</span>
                                    <span v-if="item.is_valid == 0"><button @click="hiddenNote(item,1)">显示</button></span>
                                    <span v-if="item.is_valid == 1"><button @click="hiddenNote(item,0)">隐藏</button></span>
                                    <span><button @click="removeNote(item)">删除</button></span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <pagination ref="pagination" class="paging" :total="noteTotal" :border="false" background="#f5f5f5" @handle="updateList"></pagination>
                </div>
            </c-detail>
-->
        </module>

        <c-dialog ref="commentDialog" title="评论信息" width="1000" :button="false">
            <m-search ref="commentSearch" @search="updateComment">
                <c-form ref="commentForm" inline>
                    <c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="评论内容" name="content"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="commentList" height="600">
                <c-table-column
                        label="评价类型"
                        width="100"
                        name="commend_type"
                ></c-table-column>

                <c-table-column
                        label="用户信息"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name}}</span>
                        </div>
                    </template>
                </c-table-column>

                <!--                <c-table-column
                                        label="评价对象"
                                        width="200"
                                        name="comment_content"
                                ></c-table-column>-->

                <c-table-column
                        label="内容"
                        width="450"
                        name="content"
                ></c-table-column>

                <c-table-column
                        label="评论时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="100"
                >
                    <template v-slot="row">
                        <c-table-button @click="removeComment(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
    </page>
</template>

<script>
    import pagination from '@/components/public/pagination.vue'

    export default {
        name: 'moments_topic_detail',

        components: {
            pagination
        },

        props: {
            id: String
        },

        data() {
            return {
                detailInfo: {},
                noteList: [],
                noteTotal: 0,
                mediaList: []
            }
        },

        watch: {
            id() {
                this.updateDetail();
                this.$refs.pagination.update(1);
            }
        },

        mounted() {
            this.updateDetail();
            // this.$refs.pagination.update(1);
        },

        methods: {
            updateDetail() {
                this.request({
                    url: '/moments/detail',
                    data: {
                        id: this.id
                    },
                    success: data => {
                        this.detailInfo = data;
                        this.mediaList = data.media_list||[];
                    }
                });
            },

            updateList(data) {
                this.request({
                    url: '/moments/detail_list',
                    data: Object.assign(data, {
                        id: this.id
                    }),
                    success: data => {
                        this.noteList = data;
                    },
                    response: res => {
                        this.noteTotal = res.total;
                    }
                });
            },

            removeNote(item) {
                this.$confirm({
                    text: '确定要删除此话题吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments/del_detail',
                            data: {
                                id: item.id
                            },
                            loading: true,
                            success: data => {
                                this.$refs.pagination.update();
                            }
                        });
                    }
                });
            },

            hiddenNote(item,state) {
                this.$confirm({
                    text: '确定要' + (state == 1 ? '显示' : '隐藏') +'该内容吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_edit_valid_state',
                            data: {
                                ids: [item.id],
                                is_valid: state,
                            },
                            loading: true,
                            success: data => {
                                this.$refs.pagination.update();
                            }
                        });
                    }
                });
            },

            showComment(item) {
                this._noteId = item.id;
                this.$refs.commentForm.clear();
                this.$refs.commentSearch.search();
                this.$refs.commentDialog.open();
            },

            updateComment(data) {
                data.moments_id = this._noteId;
                this.$refs.commentList.load({
                    url: '/moments_comment/list',
                    data
                });
            },

            removeComment(row) {
                this.$confirm({
                    text: '确定要删除此评论吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments_comment/del',
                            data: {
                                id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$refs.commentList.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .list {
    margin-bottom: 10px;

    .item {
      border: 1px solid #eee;
      overflow: hidden;

      &:nth-child(n+2) {
        border-top: none;
      }

      .img-list {
        margin: 16px 22px 0;

        .img {
          margin-right: 12px;
        }
      }

      .content {
        margin: 16px 22px;
        line-height: 24px;
        color: #333;
      }

      .data {
        height: 40px;
        border-top: 1px solid #eee;
        padding: 0 12px 0 22px;
        font-size: 13px;
        color: #444;
        background: #F9F9F9;

        span {
          margin-right: 14px;
        }

        button {
          width: 40px;
          height: 24px;
          border: none;
          border-radius: 2px;
          font-size: 12px;
          color: #fff;
          background: #e00;

          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  .paging {
    position: sticky;
    bottom: 0;
  }
</style>